var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01677 7.59366C0.90328 7.41396 0.846535 7.32411 0.81477 7.18553C0.79091 7.08143 0.79091 6.91727 0.81477 6.81317C0.846535 6.67458 0.90328 6.58473 1.01677 6.40503C1.95461 4.92005 4.74617 1.16602 9.00034 1.16602C13.2545 1.16602 16.0461 4.92005 16.9839 6.40503C17.0974 6.58473 17.1541 6.67458 17.1859 6.81317C17.2098 6.91727 17.2098 7.08143 17.1859 7.18553C17.1541 7.32411 17.0974 7.41396 16.9839 7.59366C16.0461 9.07865 13.2545 12.8327 9.00034 12.8327C4.74617 12.8327 1.95461 9.07865 1.01677 7.59366Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00034 9.49935C10.381 9.49935 11.5003 8.38006 11.5003 6.99935C11.5003 5.61864 10.381 4.49935 9.00034 4.49935C7.61962 4.49935 6.50034 5.61864 6.50034 6.99935C6.50034 8.38006 7.61962 9.49935 9.00034 9.49935Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.34ecf9f51194f8bba63c2624581b189e.svg";
export { ForwardRef as ReactComponent };